<template>
  <div :class="[ns.e('item'), ns.e(variant)]">
    <Image v-if="variant === 'image'" />
  </div>
</template>

<script lang="ts" setup>
import { useNamespace } from '@bigin/hooks'
import { Image } from '@bigin/icons-vue'
import { skeletonItemProps } from './skeleton-item'

defineOptions({
  name: 'BSkeletonItem',
})
defineProps(skeletonItemProps)
const ns = useNamespace('skeleton')
</script>
